import React from "react"
import clsx from "clsx"

import classes from "./Switch.module.scss"

const Switch = props => {
  const {
    color = "primary",
    className = "",
    children,
    onClick = () => {},
    disabled = false,
    checked = false,
    ...otherProps
  } = props

  return (
    <div className={clsx(className, classes["container"])}>
      <div
        onClick={() => onClick(!checked)}
        className={clsx(classes["slider"],
          checked && classes[`active-${color}`],
          disabled && classes["disabled"]
        )}

        {...otherProps}
      />
    </div>
  )
}

export default Switch